var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3c.021 0 .039.011.061.012a1 1 0 01.265.054c.032.011.064.019.094.034.102.047.2.108.284.191l.002.001 5.892 5.892a.997.997 0 01.422.816l-.009.05-.011.049V22a2.002 2.002 0 01-1.85 1.995L14 24H2a2.002 2.002 0 01-1.995-1.85L0 22V5c0-1.053.817-1.918 1.85-1.995L2 3h7zM8 5H2v17h12V11H9a1 1 0 01-.993-.883L8 10V5zm9-5c.022 0 .04.011.062.013a.96.96 0 01.264.053c.032.011.064.019.094.034.103.047.2.108.284.191l.002.001 5.892 5.892A.997.997 0 0124.02 7l-.009.05-.011.049V19a2.002 2.002 0 01-1.85 1.995L22 21h-4a1 1 0 01-.117-1.993L18 19h4V8h-5a1 1 0 01-.993-.883L16 7V2H9A1 1 0 018.883.007L9 0h8zm-7 6.414V9h2.586L10 6.414zm8-3V6h2.586L18 3.414z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconCopy;